import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Timer } from 'lucide-react';
export function LimitedOffer() {
  const {
    minutes,
    seconds
  } = useCountdown();
  return <section className="pt-20 pb-10 px-4" data-id="element-131">
      <div className="max-w-3xl mx-auto text-center" data-id="element-132">
        <h2 className="font-serif text-3xl md:text-4xl text-brown font-bold mb-8" data-id="element-133">
          Oferta por tiempo limitado
        </h2>

        <div className="inline-flex items-center gap-3 bg-red-50 text-red-600 px-6 py-3 rounded-full font-sans font-bold text-xl md:text-2xl mb-8 border border-red-100 shadow-sm" data-id="element-134">
          <Timer className="w-6 h-6 animate-pulse" data-id="element-135" />
          <span className="w-12 text-center" data-id="element-136">
            {minutes.toString().padStart(2, '0')}
          </span>
          <span data-id="element-137">:</span>
          <span className="w-12 text-center" data-id="element-138">
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gold/20 mb-8" data-id="element-139">
          <p className="font-sans text-brown/60 mb-2" data-id="element-140">
            Valor real del sistema:{' '}
            <span className="line-through" data-id="element-141">$65.990</span>
          </p>
          <div className="flex items-center justify-between font-sans text-sm font-bold text-brown mb-2" data-id="element-142">
            <span data-id="element-143">🔥 Cupos de la promoción: 78% tomados</span>
            <span className="text-red-500" data-id="element-144">después sube a $49.990</span>
          </div>
          <div className="w-full bg-cream rounded-full h-3 overflow-hidden" data-id="element-145">
            <div className="bg-gold h-full rounded-full" style={{
            width: '78%'
          }} data-id="element-146" />
          </div>
        </div>
      </div>
    </section>;
}